import { StringOption } from '../../../../../Options/Types';
import { Resource } from '../../../../../../Resource/Types';
import { Error } from '../../../../../../ErrorHandling';

export interface DeepLinksOptions {
  deliveryChannels: StringOption[];
  programTypes: StringOption[];
  licenses: StringOption[];
}

export type DeepLinksOptionsResource = Resource<DeepLinksOptions>;

interface Waiting {
  kind: 'waiting';
}

interface Loading {
  kind: 'loading';
}

export interface Ready {
  kind: 'ready';
  resource: DeepLinksOptionsResource;
}

export const waiting = (): Waiting => ({
  kind: 'waiting',
});

export const loading = (): Loading => ({
  kind: 'loading',
});

export const ready = (resource: DeepLinksOptionsResource): Ready => ({
  kind: 'ready',
  resource,
});

export type State = Waiting | Loading | Ready | Error;
